module.exports = __webpack_public_path__ + "img/app-preview.fb198d92.png";